module.exports = __webpack_public_path__ + "img/phone-bg.52ecad42.png";